import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import {
	notifyError,
	parseJSON,
	findProjects as queryProjects,
	getKeysFromColumnHeaders,
} from "utils";
import store, { dispatch } from "store/store";
import { projects as constants } from "store/constants";
import { actionFactory as feedActionFactory } from "store/factories/feed";
import { actionLoaderFactory } from "store/factories/fetchable";
import { IS_DEV, PROJECT_SUMMARY_ITEMS } from 'globals/constants';
import { countNumberSummaryItems } from "utils/summary";
import Pager from "components/Pager";

import { columnsSelectors, projectListSelectors } from "../selectors";
import { api } from "services";


export const { addItems, setPaging } = feedActionFactory(constants);

const listFactory = actionLoaderFactory(constants, constants.PROJECT_LIST);
const summaryFactory = actionLoaderFactory(constants, constants.PROJECT_LIST_SUMMARY);

export const setProjectSearchBar = search => {
	dispatch({ type: constants.SET_SEARCH, search: isNonEmptyString(search) ? parseJSON(search) : search });
};

export const findProjects = async ({ pageLimit, pageOffset, searchTerms }) => {
	return listFactory.createLoaderAction(
		() => queryProjects({ pageLimit, pageOffset, searchTerms }),
		[
			(response) => {
				listFactory.setData(response);

				return response;
			},
			(error, { getState }) => {
				const message = IS_DEV ? error.message : getState().dictionary.projects.errors.projectsFailedLoad;

				notifyError(message, error);
				listFactory.setError(message);
			},
		],
	);
};

export const getProjectSummary = async () => {
	return summaryFactory.createLoaderAction(
		api.project.getSummary,
		[
			(response) => {
				summaryFactory.setData(countNumberSummaryItems(PROJECT_SUMMARY_ITEMS, response));
			},
			(error, { getState }) => {
				const message = IS_DEV ? error.message : getState().dictionary.projects.errors.tilesFailedLoad;

				notifyError(message, error)
				summaryFactory.setError(message);
			},
		],
	);
};

export const refreshProjects = () => {
	const state = store.getState();
	const {
		search: searchTerms,
		paging: {
			pageNumber,
			pageLimit,
		},
	} = projectListSelectors.content(state);
	const { activeColumns } = columnsSelectors.projects(state);

	const pageOffset = Pager.pageOffsetByPageNumber(pageNumber);
	const fieldKeys = getKeysFromColumnHeaders(activeColumns);

	getProjectSummary();
	findProjects({ pageLimit, pageOffset, searchTerms, fieldKeys, isRefresh: true });
};
